function debounce(duration, fn) {
  let timeout;
  const debounced = function(...args) {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      timeout = null;
      fn(...args);
    }, duration);
  };
  debounced.cancel = () => {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  return debounced;
}
export {
  debounce
};
//# sourceMappingURL=debounce.js.map
